import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M18 1c.552 0 1 .448 1 1V7.892c0 .46-.187.877-.49 1.178L9 18.59c-.255.257-.609.416-1 .416s-.745-.159-1-.416L1.41 13c-.257-.255-.416-.609-.416-1s.159-.745.416-1l9.52-9.52c.3-.297.712-.48 1.168-.48H18zm0-1H12.106c-.736 0-1.403.298-1.886.78L.71 10.3c-.434.436-.702 1.037-.702 1.7s.268 1.264.702 1.7l5.6 5.6c.436.434 1.037.702 1.7.702s1.264-.268 1.7-.702l9.52-9.52c.476-.482.77-1.145.77-1.876V2c0-1.105-.895-2-2-2zm-3 4c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm0-1c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2z',
  ],
  height: 20,
  width: 20,
});
